import type { App } from "vue";
import { createI18n } from "vue-i18n";
import { getAllMessages } from "@/plugins/i18n/helper";

const currentLocale = "zh";

// 当前仅仅支持中文，无切换功能，需要切换语言时，需要重新写该文件的逻辑
const createI18nOptions = () => {
  return {
    locale: currentLocale, // 设置默认语言
    messages: {
      zh: getAllMessages(currentLocale),
    },
  };
};

const options = createI18nOptions();

const i18n = createI18n(options);

const registerI18n = (app: App) => {
  app.use(i18n);
};

export const getI18n = () => {
  return i18n;
};

export const t = i18n.global.t;

export default registerI18n;
